import axios from "axios";
import { keycloakInterceptor } from "../auth/keycloakService";
import { errorMessage } from "../utils/messages";
import { IDocumentoArquivo } from "../Interfaces/DadosPrevicInterfaces";

const apiDocumentos = axios.create({
  baseURL: process.env.REACT_APP_URL_API_DOCUMENTOS,
});

apiDocumentos.interceptors.request.use(keycloakInterceptor);


export const getDocPdf = async (id: number) => {
  try {
    const { data } = await apiDocumentos.get<IDocumentoArquivo>(
      `/documentos/buscar/id/${id}`
    );
    window.open(`${process.env.REACT_APP_URL_API_DOCUMENTOS}${data.path}`);
  } catch (error) {
    errorMessage("Não foi possível abrir o documento selecionado");
  }
};

export const urlDeUpload = `${process.env.REACT_APP_URL_API_DOCUMENTOS}/documentos/upload`;
